import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  Collapse,
  Icon,
} from "@material-ui/core";

const MobileRecursiveMenu = ({ items, classes, parseTitle, level = 0 }) => {
  return (
    <List disablePadding>
      {items.map((item, index) => (
        <MobileMenuItem
          key={item.url || index}
          item={item}
          classes={classes}
          parseTitle={parseTitle}
          level={level}
        />
      ))}
    </List>
  );
};

const MobileMenuItem = ({ item, classes, parseTitle, level }) => {
  const [open, setOpen] = useState(false);
  const hasSubmenu = item.submenu && item.submenu.length > 0;

  const handleToggle = (e) => {
    e.preventDefault();
    setOpen(!open);
  };

  return (
    <>
      <ListItem
        button
        component="a"
        href={hasSubmenu ? undefined : item.url}
        onClick={hasSubmenu ? handleToggle : undefined}
        style={{ paddingLeft: level * 16 }}
        className={classes.cssSubmenuItem}
        role="menuitem"
        aria-expanded={hasSubmenu ? open : undefined}
        aria-haspopup={hasSubmenu ? "true" : undefined}
      >
        <ListItemText primary={parseTitle(item.title)} style={item.style} />
        {hasSubmenu && <Icon>{open ? "expand_less" : "expand_more"}</Icon>}
      </ListItem>
      {hasSubmenu && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <MobileRecursiveMenu
            items={item.submenu}
            classes={classes}
            parseTitle={parseTitle}
            level={level + 1}
          />
        </Collapse>
      )}
    </>
  );
};

export default MobileRecursiveMenu;
